import kubecon from '../../assets/about/KubeCon.JPG';
import kubecon1 from '../../assets/about/IMG_1917.jpg';
import wayneHacks from '../../assets/Hackathons/Waynehacks.jpeg';
import k8stalk from '../../assets/about/K8s_talk_post.jpg';
import edcl from '../../assets/pdfs/edge_cloud_offloading.pdf';
import cg from '../../assets/pdfs/Cloud_gaming.pdf';

export const aboutData = {
  heading: "What did I do in the United States of America?",
  sections: [
    {
      title: "Master's of Science at University of Michigan",
      imageUrls: [k8stalk],
      details: "Graduated with a focus on Cloud and Edge Computing. Delivered talks on Kubernetes and Docker, designed labs for students to work on-prem servers."
    },
    {
      title: "Research Papers",
      papers: [
        {
          title: "A Survey on How Edge Computing can be Used to Improve the Performance of Cloud Gaming",
          abstract: "Cloud gaming continues to progress towards its goal of allowing users to play any game, anywhere, anytime. By hosting on cloud data centers, games are streamed to the player without the need for an expensive gaming console or computer. However, there are still several challenges facing cloud gaming, with the most prominent being high latency. Edge computing has proposed many solutions to minimize latency that can be applied to cloud gaming to improve its performance. This survey paper discusses existing works, followed by our findings that we have extrapolated from them.",
          pdf: cg
        },
        {
          title: "Privacy-preserving Computation Offload for Native Applications via Home Routers",
          abstract: "Android developers often implement computationintensive tasks in native languages like C/C++ to improve application performance; these applications are known as native applications. Due to their heavy computational workload, native applications typically consume significant energy, rapidly draining mobile device batteries. Offloading these tasks to external devices with stable power supplies is an effective approach to address this issue. However, existing solutions primarily rely on public cloud or edge servers, which pose privacy risks when processing sensitive user data. Motivated by the availability of user-controlled home routers with spare computational resources, this paper proposes a system that offloads native application tasks to home routers, simultaneously achieving energy efficiency and privacy preservation. We address two critical challenges in designing our system: (a) reducing developer overhead by introducing a dedicated programming model that simplifies the integration of offloading capabilities into applications; and (b) ensuring task QoS performance on resource-constrained routers through an intelligent offloading decision engine. Evaluation results from a real-world testbed demonstrate that our system reduces mobile device energy consumption by up to xx% compared to on-device execution, without violating the QoS requirements of applications.",
          pdf: edcl
        }
      ]
    },
    {
      title: "Fellowship",
      details: "SWE Fellow @ Headstarter AI: Led development of ShelfSense, full-stack intelligent inventory and recipe suggestion platform using React, GCP Firestore, Vertex AI, and OpenAI API."
    },
    {
      title: "Conferences Attended",
      imageUrls: [kubecon, kubecon1],
      details: "KubeCon + CloudNativeCon, Michigan DevFest, Black Tech Summit, Cyber Security Summit."
    },
    {
      title: "Hackathons Participated",
      imageUrls: [wayneHacks],
      details: "HackDearborn 2, HackDearborn 3, Wayne Hacks."
    },  
  ]
};
